import React from "react";
import Image from "next/image";
// nodejs library that concatenates classes
import classNames from "classnames";

// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

// core components


import ScriptEmbed from "/tribalism-component/script-embed.js";
import styles from "../../../../services/ServicesSections.module.scss";



export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={8} md={8}>
          <a className={classes.anchor} id="start"></a>
          <p>This tweet says it all. </p>
        </GridItem>
        <div style={{ textAlign: "center", maxWidth: "400px", width: "100%" }}>
          <blockquote className="twitter-tweet">
            <p lang="en" dir="ltr">
              New in Data Studio: Add{" "}
              <a href="https://twitter.com/googlemaps?ref_src=twsrc%5Etfw">
                @googlemaps
              </a>{" "}
              to your reports and let viewers see your data in a whole new
              geographic dimension.
              <br />
              <br />
              Google Maps in Data Studio are interactive and integrate with any
              data source that contains valid geo fields.{" "}
              <a href="https://t.co/UXlfedkjyV">https://t.co/UXlfedkjyV</a>{" "}
              <a href="https://twitter.com/hashtag/measure?src=hash&amp;ref_src=twsrc%5Etfw">
                #measure
              </a>{" "}
              <a href="https://t.co/9kLvYjFhzl">pic.twitter.com/9kLvYjFhzl</a>
            </p>
            &mdash; Google Analytics (@googleanalytics){" "}
            <a href="https://twitter.com/googleanalytics/status/1256272860726939650?ref_src=twsrc%5Etfw">
              May 1, 2020
            </a>
          </blockquote>
          <ScriptEmbed
            src={`https://platform.twitter.com/widgets.js`}
            charSet={`utf-8`}
            scriptId={`twitter-widget`}
          />
        </div>

        <GridItem xs={12} sm={8} md={8}>
          <p>
            Data Studio, data studio, data studio… such a great tool - but
            always missing that last little bit. There's been lots of great
            visualizations made with data studio but when you've wanted to push
            it just that little bit further - you've been presented with the
            limitations of a “free” tool. Want some extra complicated functions
            or metrics? Data studio has a lot - just not as many as a paid for
            competitor like Tableau or Power BI.
            <br />
            <br />
            Data Studio only has limited text functions. Want everything in
            UPPER case? No problem. PROPER case… er sorry we don't have that -
            you'll have to fix your data somewhere else (eg BigQuery) first.
            Sure that's not “massive” issue - but there's always that small
            thing that makes it clear that data studio, great as it is, has not
            been “finished” to the degree of a paid for tool.
            <br />
            <br />
            One of the most famous bugbears has been the mapping of course. In
            previous versions of Data Studio, Map zooms were limited to country
            level outside of the United States. The map of Australia is/was very
            frustrating… why does it always include New Zealand? The New Zealand
            one is not too bad I guess… I notice it still includes a bit of “the
            big island” though.
          </p>
        </GridItem>

        <div style={{ textAlign: "center", maxWidth: "600px" }}>
          <GridItem xs={12} sm={12} md={12}>
            <Image
              objectFit="contain"
              layout="responsive"
              width={525}
              height={355}
              src="/img/posts/2020-05-04-GoogleMaps-in-data-studio/new google maps 1-resize.webp"
              alt="..."
              className={imgClasses}
            />
            <p>
              <br></br>
              <i>
                Australia... plus the extra bits you dont want in old school
                data studio maps
              </i>
            </p>
          </GridItem>
        </div>

        <div style={{ textAlign: "center", maxWidth: "600px" }}>
          <GridItem xs={12} sm={12} md={12}>
            <Image
              objectFit="contain"
              layout="responsive"
              width={530}
              height={358}
              src="/img/posts/2020-05-04-GoogleMaps-in-data-studio/new google maps 2-resize.webp"
              alt="..."
              className={imgClasses}
            />
            <p>
              <br></br>
              <i>
                New Zealand looks ok... but it still includes a bit of “the big
                island”
              </i>
            </p>
          </GridItem>
        </div>

        <GridItem xs={12} sm={8} md={8}>
          <p>The big problems here are:</p>
          <ol>
            <li>
              <strong>No zoom control</strong> either by the user in view mode
              OR by the creator in edit mode. Youre stuck with the image above
              always
            </li>

            <li>
              <strong>Only Country view</strong> similar to above. If you want
              to zoom into state or city or even smaller level, you cant. For a
              massive country like Australia this is a big problem. Cities like
              Sydney and Melbourne swallow up all the satellite towns around
              them into one big blob
            </li>

            <li>
              <strong>No finer controls</strong> Wanna change bubble size? Or
              colour for different metrics… Nope - your stuck with the standard
              views above…
            </li>
          </ol>

          <p>…until now!</p>

          <h3 className={classes.title}>
            First look at Google Maps in Data Studio{" "}
          </h3>

          <p>
            So Google has added Google Maps as a chart type in Data Studio!!!
          </p>
        </GridItem>

        <div style={{ textAlign: "center", maxWidth: "500px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <Image
              objectFit="contain"
              layout="responsive"
              width={334}
              height={351}
              src="/img/posts/2020-05-04-GoogleMaps-in-data-studio/new google maps 3-resize.webp"
              alt="..."
              className={imgClasses}
            />
          </GridItem>
        </div>

        <GridItem xs={12} sm={8} md={8}>
          <br />
          <p>
            Heh.. I see your eyebrows raised. Yes that same ubiquitous Google
            maps is now a chart option in Data Studio. So all the bells and
            whistles of Google Maps are there too… what does this actually
            mean??? *Excited expression
          </p>

          <div
            className="tenor-gif-embed"
            data-postid="16391814"
            data-share-method="host"
            data-width="100%"
            data-aspect-ratio="1.3351206434316354"
          >
            <a href="https://tenor.com/view/oh-snap-wow-mindblown-cool-amazing-gif-16391814">
              Oh Snap Wow GIF
            </a>{" "}
            from <a href="https://tenor.com/search/ohsnap-gifs">Ohsnap GIFs</a>
          </div>
          <ScriptEmbed
            type="text/javascript"
            async=""
            src="https://tenor.com/embed.js"
            scriptId='tenor-embed'
          />

          <br />
          <p>It means:</p>
          <h3 className={classes.title}>
            1) Google Maps is a Chart Option in Data Studio
          </h3>
          <p>
            {" "}
            Tool Tip and Bubble Size/Colour are the highlights of the new chart
            type data options. Bubble size allows you to assign different
            metrics for size and colour - GREAT! This way you can compare things
            like users v profitability per user... :-) Tool tip is a nice
            addition where end users can see actual metric and dimension values
            by hovering over data points on the map. You have fine grain control
            over what is displayed
          </p>
        </GridItem>

        <div style={{ textAlign: "center", maxWidth: "400px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <Image
              objectFit="contain"
              layout="responsive"
              width={273}
              height={618}
              src="/img/posts/2020-05-04-GoogleMaps-in-data-studio/new google maps 4-resize.webp"
              alt="..."
              className={imgClasses}
            />
          </GridItem>
        </div>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>
            2) You can now change maps to be in Satellite view
          </h3>
          <p>The image below shows Australia in all its red/brown glory.</p>
        </GridItem>

        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <Image
              objectFit="contain"
              layout="responsive"
              width={770}
              height={364}
              src="/img/posts/2020-05-04-GoogleMaps-in-data-studio/new google maps 5-resize.webp"
              alt="..."
              className={imgClasses}
            />
          </GridItem>
        </div>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>
            3) There are further fine grained controls on what is shown in maps
          </h3>
          <p>
            The images below show Sydney Harbour, Google Maps style in Data
            Studio
          </p>
        </GridItem>

        <div style={{ textAlign: "center", maxWidth: "770px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <Image
              objectFit="contain"
              layout="responsive"
              width={770}
              height={343}
              src="/img/posts/2020-05-04-GoogleMaps-in-data-studio/new google maps 6-resize.webp"
              alt="..."
              className={imgClasses}
            />
            <p>
              <br></br>
              <i>Sydney Harbour with "Roads" Highlighted</i>
            </p>
          </GridItem>
        </div>

        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <Image
              objectFit="contain"
              layout="responsive"
              width={770}
              height={347}
              src="/img/posts/2020-05-04-GoogleMaps-in-data-studio/new google maps 7-resize.webp"
              alt="..."
              className={imgClasses}
            />
            <p>
              <br></br>
              <i>Sydney Harbour with "Labels" and "Landmarks" Highlighted</i>
            </p>
          </GridItem>
        </div>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>
            4) Addresses are a new data type in Data Studio amazing!
          </h3>
          <p>There is a new address data type in Data Studio. See below.</p>
        </GridItem>

        <div style={{ textAlign: "center", maxWidth: "600px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <Image
              objectFit="contain"
              layout="responsive"
              width={564}
              height={402}
              src="/img/posts/2020-05-04-GoogleMaps-in-data-studio/new google maps 8-resize.webp"
              alt="..."
              className={imgClasses}
            />
            <p>
              <br></br>
              <i>Address data types</i>
            </p>
          </GridItem>
        </div>

        <GridItem xs={12} sm={8} md={8}>
          <p>
            In our experience this field is phenomenal - but its only as good as
            the data you throw at it. If you put in say “Newport” as your
            address, it seems to generally default to the USA version of
            “Newport”. See Scott’s post on the official Google Analytics Twitter
            account here:
          </p>
        </GridItem>
        <div style={{ textAlign: "center", maxWidth: "400px" }}>
          <blockquote className="twitter-tweet">
            <p lang="en" dir="ltr">
              Note: Town/City doesnt work properly in Adwords (example source in
              link). Eg see image - it reports &quot;Brisbane&quot; as being in
              California. Even filtering by country doesnt work. You need to
              create a new field (I did concat(ctry,region,city)) and make it
              and &quot;Address type&quot; :-){" "}
              <a href="https://t.co/leS2X3w1NG">pic.twitter.com/leS2X3w1NG</a>
            </p>
            &mdash; Scott Sunderland (@ScottSunderl4nd){" "}
            <a href="https://twitter.com/ScottSunderl4nd/status/1256474335214096384?ref_src=twsrc%5Etfw">
              May 2, 2020
            </a>
          </blockquote>
          <ScriptEmbed
            src={`https://platform.twitter.com/widgets.js`}
            charSet={`utf-8`}
            scriptId={`twitter-embed-2`}
          />
        </div>

        <GridItem xs={12} sm={8} md={8}>
          <p>
            The above was in reference to an Adwords account that was targeting
            Australian users only. The mapping tool in Data studio for this
            connector fails to realise which version of a “Town/City” you are
            referring too. For example, if you're adwords campaign is targeting
            only Australia - Google Maps still doesnt know where "Newport" is.
            You need to specify which country and city you mean.
          </p>

          <p>
            This is easily fixed though. Like above, by creating a calculated
            field that concatenates something to define which city/country you
            are talking about. Above we concatenated “," + "Australia” and this
            fixed the problem.
          </p>

          <h3 className={classes.title}>
            Playing Around With Google Maps in Data Studio{" "}
          </h3>

          <p>
            We had a few hours to throw together some things in Data Studio with
            the new google maps functionality. And this is what we came up with
          </p>

          <p>
            First up the integration needs help in finding incomplete addresses.
            See below. This is a view of data linked straight to the{" "}
            <strong>Google Analytics datasource</strong>. The “addresses” in
            this case are in fact page titles for a review website. They include
            the place name and suburb e.g. Olive Oil And Butter, Kingsville (a
            suburb of Melbourne). When applying this combination in Data Studio,
            Google Maps will default to the Suburb level - in this case
            Kingsville. Now that’s pretty great still… See the visualisation
            below. But it’s not going to find the “actual address” for you which
            would be much nicer than "lumping" them all in to the same suburb...
          </p>

          <p>To do that your gonna need some help…</p>
        </GridItem>

        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <Image
              objectFit="contain"
              layout="responsive"
              width={770}
              height={387}
              src="/img/posts/2020-05-04-GoogleMaps-in-data-studio/new google maps 17-resize.webp"
              alt="..."
              className={imgClasses}
            />
            <p>
              <br></br>
              <i>Google Maps needs help guessing some places/landmarks</i>
            </p>
          </GridItem>
        </div>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>
            Geocoding API anyone??? Or Places API perhaps??
          </h3>

          <p>
            {" "}
            Surely there’s a quick way to convert these pesky “half addresses”?
            Mannnn… this is the Big G we are talking about. (Or the big S…
            Stackexhange, whichever you prefer!). A few taps and clicks got us
            to{" "}
            <a
              href="https://stackoverflow.com/questions/34550057/retrieving-location-address-based-on-place-name-and-city-in-google-spreadsheet"
              target="_blank"
            >
              here
            </a>
          </p>

          <p>This is the code we used: </p>
        </GridItem>

        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <Image
              objectFit="contain"
              layout="responsive"
              width={770}
              height={253}
              src="/img/posts/2020-05-04-GoogleMaps-in-data-studio/new google maps 11-resize.webp"
              alt="..."
              className={imgClasses}
            />
            <p>
              <br></br>
              <i>Address data types</i>
            </p>
          </GridItem>
        </div>

        <GridItem xs={12} sm={8} md={8}>
          <p>
            {
              "function mapAddress(address) { var API_KEY = 'yourapikeyhere'; var url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + address + '&lang=en&key=' + API_KEY; var response = UrlFetchApp.fetch(url); var json = response.getContentText(); obj = JSON.parse(json); addr = obj.results[0].formatted_address; return addr; }"
            }
          </p>
          <p>
            Thanks Bastians{" "}
            <a
              href="https://stackoverflow.com/users/4382309/bastians"
              target="_blank"
            >
              https://stackoverflow.com/users/4382309/bastians
            </a>
          </p>

          <h3 className={classes.title}>
            How to use the Google Places or Google Geocoding API
          </h3>
          <p>How do you set this up? Pretty simple.</p>

          <ol>
            <li>
              Create a new project in Google Cloud Console (which has billing
              allowed){" "}
              <a href="https://cloud.google.com/resource-manager/docs/creating-managing-projects">
                This is easy.
              </a>
            </li>
            <li>
              Enable the API you want (in our case the Geocoding API). See below{" "}
            </li>
          </ol>
        </GridItem>

        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <Image
              objectFit="contain"
              layout="responsive"
              width={770}
              height={253}
              src="/img/posts/2020-05-04-GoogleMaps-in-data-studio/new google maps 9-resize.webp"
              alt="..."
              className={imgClasses}
            />
            <p>
              <br></br>
              <i>
                <a
                  href="https://developers.google.com/maps/gmp-get-started"
                  target="_blank"
                >
                  https://developers.google.com/maps/gmp-get-started
                </a>
              </i>
            </p>
          </GridItem>
        </div>

        <GridItem xs={12} sm={8} md={8}>
          <ol start="3" style={{fontSize: '1.188rem'}}>
            <li>Get an API Key. Follow these steps:</li>
          </ol>
        </GridItem>

        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <Image
              objectFit="contain"
              layout="responsive"
              width={770}
              height={350}
              src="/img/posts/2020-05-04-GoogleMaps-in-data-studio/new google maps 10-resize.webp"
              alt="..."
              className={imgClasses}
            />
            <p>
              <br></br>
              <i>
                <a
                  href="https://developers.google.com/maps/documentation/geocoding/get-api-key"
                  target="_blank"
                >
                  https://developers.google.com/maps/documentation/geocoding/get-api-key
                </a>
              </i>
            </p>
          </GridItem>
        </div>

        <GridItem xs={12} sm={8} md={8}>
          <ol start="4" style={{fontSize:'1.188rem'}}>
            <li>
              Add to your script in Apps Script. Theres various ways to do
              this. We created a contained (ie lives in the google sheet) apps
              script through Google sheets.
            </li>
          </ol>
        </GridItem>

        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <Image
              objectFit="contain"
              layout="responsive"
              width={770}
              height={253}
              src="/img/posts/2020-05-04-GoogleMaps-in-data-studio/new google maps 11-resize.webp"
              alt="..."
              className={imgClasses}
            />
            <p>
              <br></br>
              <i>
                <a
                  href="https://developers.google.com/maps/documentation/geocoding/get-api-key"
                  target="_blank"
                >
                  https://developers.google.com/maps/documentation/geocoding/get-api-key
                </a>
              </i>
            </p>
          </GridItem>
        </div>

        <div style={{ textAlign: "center", maxWidth: "400px" }}>
          <GridItem xs={12} sm={12} md={12}>
            <Image
              objectFit="contain"
              layout="responsive"
              width={370}
              height={203}
              src="/img/posts/2020-05-04-GoogleMaps-in-data-studio/new google maps 11-1-resize.webp"
              alt="..."
              className={imgClasses}
            />
          </GridItem>
        </div>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>
            Adding images to Tables in Data Studio
          </h3>
          <p>
            So in order to get the addresses right we had to go to google sheets
            as an intermediary step. Ok then.. While we are there why don't we
            take advantage of another (older but still cool) feature of data
            studio? The IMAGE function. Quick search… and our friends at
            ClickInsight remind us how: <br />
            <a
              href="https://www.clickinsight.ca/blog/adding-images-to-your-tables-data-studio"
              target="_blank"
            >
              https://www.clickinsight.ca/blog/adding-images-to-your-tables-data-studio
            </a>
          </p>
        </GridItem>

        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <Image
              objectFit="contain"
              layout="responsive"
              width={770}
              height={387}
              src="/img/posts/2020-05-04-GoogleMaps-in-data-studio/new google maps 12-resize.webp"
              alt="..."
              className={imgClasses}
            />
            <p>
              <br></br>
              <i>How to use the IMAGE function</i>
            </p>
          </GridItem>
        </div>

        <div style={{ textAlign: "center", maxWidth: "670px" }}>
          <GridItem xs={12} sm={12} md={12}>
            <Image
              objectFit="contain"
              layout="responsive"
              width={669}
              height={386}
              src="/img/posts/2020-05-04-GoogleMaps-in-data-studio/new google maps 13-resize.webp"
              alt="..."
              className={imgClasses}
            />
            <p>
              <br></br>
              <i>
                And how we deployed this in Data Studio... easy as you can see!
              </i>
            </p>
          </GridItem>
        </div>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Final results!</h3>
          <p>
            In the visualization below we are looking at various reviewed
            locations around western melbourne. Bubble size is the number of
            users for each page. Colour is determined by Avg. Pages / Session
            which we are using to measure engagement.{" "}
          </p>

          <p>
            Seems pretty clear below that the frequently visited pages may lower
            engagement than the less frequently visited pages. Maybe these high
            traffic pages had campaigns or something running?
          </p>
        </GridItem>

        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <Image
              objectFit="contain"
              layout="responsive"
              width={770}
              height={392}
              src="/img/posts/2020-05-04-GoogleMaps-in-data-studio/newgooglemaps16-resize.webp"
              alt="..."
              className={imgClasses}
            />
            <p>
              <br></br>
              <i>
                We include a table graph with images inserted using the IMAGE
                function as described above
              </i>
            </p>
          </GridItem>
        </div>

        <GridItem xs={12} sm={8} md={8}>
          <p>
            From here there is no limit really. Get ready for some super awesome
            dashboards from everyone around the world (and us of course too!)
            over the coming few weeks and months. Thanks for reading!
          </p>

          <p>--------------</p>
          <p>
            Check out more about the awesome{" "}
            <a href="/services-we-offer/data-studio-services">
              Data Studio Services
            </a>{" "}
            we offer!
          </p>
        </GridItem>
      </GridContainer>
    </div>
  );
}
